import React, { createRef, Component } from 'react';
import { connect } from 'react-redux';
import { getOnboardingState } from '../../store/selectors';
import CareerPathCard from './CareerPathCard';
import CloseOutPathButton from './utility/CloseOutPathButton';
import CareerPathList from './CareerPathList';

// This holds all 3 career tabs
class CareerPathTabs extends Component {
  constructor(props) {
    super(props);

    this.tab1 = createRef();
    this.tab2 = createRef();
    this.tab3 = createRef();
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.onboarding.currentTab !== prevProps.onboarding.currentTab) {
      return this[
        `tab${this.props.onboarding.currentTab}`
      ]?.current?.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  careerCard = (career, image, current, tabNumber) => {
    let myClass = '';

    if (current !== tabNumber) {
      myClass = 'inactive';
    } else {
      myClass = 'active';
    }

    const allCareerCardContent =
      myClass === 'active' && this.props.onboarding.careerTabSelected ? (
        // Display both a career tab/card and the closeout button
        <div className="career-tab-career-list-container">
          <div className="closeout-button-career-card-container">
            <CloseOutPathButton
              className="closeout-button"
              overRideStyle="closeout-button"
              tenant={this.props.tenant}
              careerName={career.titleEn}
            />
            <CareerPathCard
              favorites={this.props.onboarding.favorites}
              career={career}
              image={image}
              classActive={myClass}
              tabNumber={tabNumber}
              tenant={this.props.tenant}
              isListOpen={this.props.isListOpen}
              data-cy="career-path-card"
              shortenButtonText={this.props.shortenButtonText}
              setBrightOutlookModal={this.props.setBrightOutlookModal}
            />
          </div>
          <div className="mobile-career-list-container">
            {this.props.onboarding.careerTabSelected ? (
              <CareerPathList tenant={this.props.tenant} />
            ) : null}
          </div>
        </div>
      ) : (
        // Display just a career tab/card
        <CareerPathCard
          career={career}
          favorites={this.props.onboarding.favorites}
          image={image}
          classActive={myClass}
          tabNumber={tabNumber}
          tenant={this.props.tenant}
          isListOpen={this.props.isListOpen}
          data-cy="career-path-card"
          shortenButtonText={this.props.shortenButtonText}
          setBrightOutlookModal={this.props.setBrightOutlookModal}
          id={`tab${tabNumber}`}
        />
      );

    return allCareerCardContent;
  };

  getCareerCards = () => {
    const tabs = [this.tab1, this.tab2, this.tab3];
    const careerCardList = tabs.map((tabRef, index) => {
      return (
        <div
          id={`tab${index + 1}`}
          className="career-card"
          ref={tabRef}
          key={`tab${index + 1}`}
        >
          {this.careerCard(
            this.props.onboarding.careerChoices[index + 1],
            this.props.onboarding.careerChoices[index + 1]?.image,
            this.props.onboarding.currentTab,
            index + 1
          )}
        </div>
      );
    });
    return careerCardList;
  };

  render() {
    return (
      <>
        <div
          className={
            this.props.onboarding.careerTabSelected
              ? 'career-tabs'
              : 'career-tabs-expanded'
          }
        >
          {this.getCareerCards()}
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);

  return { onboarding };
}

export default connect(mapStateToProps)(CareerPathTabs);
